<template>
  <div>
    <input type="text" class="p-3 text-sm bg-gray-200 rounded-sm outline-none" placeholder="Enter your search query...">
  </div>
</template>